var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContract = function SvgContract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M42 21v25H6V8h20V6H4v42h40V21h-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.58 40.65 9.47-7.24 11.53-20-7.94-4.55-11.53 20ZM22 29.49l10.38-17.9 4.48 2.58-10.34 17.9-5.34 4.08ZM43.39 6.88a4.58 4.58 0 1 0-7.94-4.58L32.8 6.88l7.94 4.58Zm-7.86-.73 1.65-2.86a2.58 2.58 0 1 1 4.48 2.58L40 8.74Z",
    fill: "currentColor"
  })));
};
export default SvgContract;